import './styles.scss'
import React, { useState } from 'react'
import { getFlightDateTime, lang } from 'utils/helpers'
import { usersHelpers, getFormatedDate } from 'utils'
import Attachment from '../../Attachment'
import ActivityMsg from '../../ActivityMsg'
import { sentimentAPI } from 'api'
import { MenuDotsOptions, UserAvatar } from 'components/common'
import DisplayNameMsg from '../../DisplayNameMsg'
import { MapEmbed } from 'components/common'
import ReadMoreText from 'components/common/ReadMoreText'
import { getStaticImage } from 'utils/statics'
import { chatmailProviders } from 'constants/channels'
import ChatChannelThread from '../ChatChannelThread'
import conversations from 'api/conversation/conversations'
import FailedMessage from 'components/Chat/FailedMessage'
import CloudAPITemplate from 'components/Chat/CloudAPITemplate'
import MessageStatus from 'components/Chat/MessageStatus'
import Nixi1Spinner from 'components/Nixi1Spinner'
import AttachmentDownloadError from './AttachmentDownloadError'
import FeedReactions from 'components/Chat/FeedReactions'
import { getPrimaryContact } from '../utils'
import onDownloadMultipleFiles from 'utils/downloadMultipleFiles'
import onDownloadMultipleFilesToZip from 'utils/downloadMultipleFilesToZip'
import Reactions from '../Reactions'
import { I18n } from 'react-redux-i18n'
import { convGetChannel, getChannelAndProvider } from 'utils/conversationUtil'
import { MSG_STATUS_NOT_REACTION, MSG_TYPES_NOT_REACTION } from '@nixi1/nx-constants'
import { useDispatch } from 'react-redux'
import { composerAct } from 'redux/actions'
import _ from 'lodash'

const CampaignSaleMsg = (props) => {
  const { campaign, price = {}, reference, text } = props

  return (
    <>
      {campaign && (<p>{I18n.t('dashboard_campaign')}: {campaign || ''}</p>)}
      {reference && (<p>{I18n.t('plugin_marketing_sales_reference')}: {reference || ''}</p>)}
      {price.value && (
        <p>
          {lang('plugin_marketing_sales_value')}: {' '}
          <strong>
            {price.value || 0} {price.currency || ''}
          </strong>
        </p>
      )}
      {text && <p>{text}</p>}
    </>
  )
}

const messageFormat = (props) => {
  const { type, text, content, attachments, location, metadata, restrictionTag, buttons, provider, channel, signature, signatureButton, isRemoved } = props
  const nodes = []

  if (isRemoved) {
    return (
      <div className='content msg_was_deleted' key='message-content'>
        {lang(type === 'note'? 'note_deleted' : 'info_msg_was_deleted')}
      </div>
    )
  }

  if (location) {
    nodes.push(<MapEmbed key='message-location' location={location} />)
  }

  if (metadata && ['campaign_not_sale', 'campaign_sale'].includes(type)) {
    return (
      <div className='content campaign-sale-msg' key='message-content'>
        <CampaignSaleMsg {...metadata} />
      </div>
    )
  }

  if (text || content) {
    let newText = text || content
    attachments?.length && attachments.forEach(el => {
      const attachment = el.url || el.urlLong
      newText = _.replace(newText, attachment, '').trimEnd()
    })
    buttons?.length && buttons.forEach(el => {
      const button = `${el.label} \n ${el.content}`
      newText = _.replace(newText, button, '').trimEnd()
    })

    // ESCAPE html tag
    newText = _.replace(newText, /<html lang=en>/gm, '')
    if (newText) nodes.push(
      <div className='content' key='message-content'>
        {!/<.+?>/gm.test(usersHelpers.showLinkMessages(newText)) ? (
          <>
            <ReadMoreText
              mode='characters'
              characters={340}
              customTextClassName='new-size-font'
              customButtonClassName='message-read-more'
              signatureButton={signatureButton}
            >
              {usersHelpers.showLinkMessages(newText)}
            </ReadMoreText>
            { signature ?
              <div
                className='new-size-font'
                dangerouslySetInnerHTML={{ __html: signature }}
              ></div>
              : null
            }
          </>
        ): (
          <div>
            <ReadMoreText
              mode='container'
              height={150}
              customTextClassName='new-size-font'
              customButtonClassName='message-read-more'
              signatureButton={signatureButton}
            >
              {usersHelpers.showLinkMessages(newText)}
            </ReadMoreText>
            { signature ?
              <div
                className='new-size-font'
                dangerouslySetInnerHTML={{ __html: signature }}
              ></div>
              : null
            }
          </div>
        )}
      </div>
    )
  }

  if (buttons?.length && !chatmailProviders.includes(channel)) {
    const _buttons = []
    buttons.forEach((el, idx) => {
      if(el.type !== 'postback')
        _buttons.push(
          <div
            key={`button-${idx}`}
            className={`new-size-font button-${buttons.length}`}
            dangerouslySetInnerHTML={{ __html: usersHelpers.showLinkMessages(el.content, el.label, provider) }}
          />
        )
      else
        _buttons.push(buttonPostback({ provider, button: el, btnLength: buttons.length, idx }))
    })
    nodes.push(
      <div className='content' key='buttons-content'>
        <div className={buttonsContent(0, provider)}>
          {_buttons}
        </div>
      </div>
    )
  }

  if (restrictionTag) {
    nodes.push(
      <div className='content' key='restriction'>
        <div
          dangerouslySetInnerHTML={{
            __html: lang(`${text ? 'with_msg' : 'without_msg'}_${restrictionTag}`)
          }}
        />
      </div>
    )
  }

  return nodes?.length > 0 ? <div style={{ padding: '10px 16px 0 10px' }}>{nodes}</div> : null
}

const buttonsContent = (btnLength, provider) => {
  switch(provider){
    case 'whatsapp':
    case 'twilio':
      return 'links'
    case 'instagram':
    case 'facebook':
      return 'message-buttons channels-normal'
    default:
      return 'message-buttons channels-normal'
  }
}

const buttonPostback = ({ provider, button, btnLength, idx }) => {
  switch(provider){
    case 'whatsapp':
    case 'twilio':
      return (
        <div
          key={`button-${idx}`}
          style={{ marginBottom:'10px' }}
          className={`message-buttons new-size-font button-${btnLength}`}
        >
          <span className='twillo-label'>{button.label}:</span>
          <span className='twillo-url postback-link-disable'>{button.content}</span>
        </div>
      )
    case 'instagram':
    case 'facebook':
      return (
        <div key={`button-${idx}`} className='message-buttons channels-normal '>
          <span className='chatmail-button text-ellipsis postback-disable' rel='noopener noreferrer'>
            {button.label}
          </span>
        </div>
      )
    default:
      return (
        <div key={`button-${idx}`} className='message-buttons channels-normal '>
          <span key={idx} className='chatmail-button text-ellipsis postback-disable' rel='noopener noreferrer'>
            {button.label}
          </span>
        </div>
      )
  }

}

const buttons = (buttons) => {
  if (buttons?.length > 0) {
    return (
      <div className='message-buttons channels-normal'>
        {buttons.map((it, idx) =>(
          <a key={idx}
            className={`chatmail-button text-ellipsis ${it.type === 'postback' ? 'postback-disable' :''}`}
            href={it.type !== 'postback' ? it.content :''}
            target='_blank' rel='noopener noreferrer'
          >
            {it.label}
          </a>
        ))}
      </div>
    )
  }

  return null
}

const Message = (props) => {
  const {
    user, operator, content, activitiesTypes, isOpenMessageOptionsSelector,
    toggleMessageOptionsSelector, handleMessageOption, isThread, toggleSidePopup
  } = props
  const {
    _id, type, typeTitle, date, operatorName, operatorEmail, operatorPicture,
    header, text, footer, insertBy, metadata, assignedTo, state, brandName,
    delegationName, to, cc, cco, messageId, sentiment = [], sentimentList = [], status,
    errorMessage, buttons: buttonsData = [], attachments = [], contacts, attachErrorType
  } = content

  const dispatch = useDispatch()
  const [isOpenModalThread, setIsOpenModalThread] = useState(false)
  const [dataToThread, setDataToThread] = useState({})
  const [showSignature, setShowSignature] = useState(false)
  const [contentSignature, setContentSignature] = useState('')
  const [gettingSignature, setGettingSignature] = useState(false)
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)

  const channelInfo = user.channels?.[0] || {}
  const hiddenReaction = MSG_STATUS_NOT_REACTION.includes(status) || MSG_TYPES_NOT_REACTION.includes(type)

  const handleDeleteMessageOption = () => {
    toggleMessageOptionsSelector({})
    setIsOpenRemoveModal(true)
  }

  const getSignature = async (id) => {
    try {
      setGettingSignature(true)
      const { data } = await conversations.getSignature(id)
      setContentSignature(data.content)
      setShowSignature(true)
      setGettingSignature(false)
    } catch (error) {
      setShowSignature(false)
      setGettingSignature(false)
    }
  }

  const signatureButton = () => {
    const signature = content?.signature
    if (signature) {
      return (
        <div className='wrapper-signature' onClick={()=>contentSignature ? setShowSignature(!showSignature) : getSignature(signature)}>
          <img src={getStaticImage('/icons/orange-brand/icon-signature.svg')} alt='Signature' />
          <label>{showSignature ? I18n.t('conversations_hide_signature') : I18n.t('conversations_view_signature')}</label>
          {gettingSignature && <Nixi1Spinner height='15px' width='15px' /> }
        </div>
      )
    }

    return null
  }

  const toggleDotsOptions = (e) => {
    if(e === undefined) toggleMessageOptionsSelector({ })
    else{
      e.stopPropagation()
      toggleMessageOptionsSelector({ id: _id })
    }
  }

  const toggleDelete = () => setIsOpenRemoveModal(!isOpenRemoveModal)

  const renderDotsOptions = () => {
    if (content?.isRemoved) return null
    if (isThread) return null
    if (['bot-action', 'customer_location', 'customer_not_supported', 'campaign_not_sale'].includes(type)) return null

    try {
      const provider = channelInfo.provider || ''
      const options = []

      if (!['note'].includes(type)) {
        if (['chatmail', 'whatsapp'].includes(provider)) {
          options.push({
            id: 'reply',
            name: lang('conversations_message_options_reply'),
            onClick: provider === 'chatmail'
              ? () => handleMessageOption({ type: 'reply', messageId: messageId })
              : () => {
                dispatch(composerAct.setReply({
                  id: _id,
                  attachments,
                  text,
                  buttons: buttonsData,
                  date: date
                }))

                toggleDotsOptions()
              }
          })
        }

        if (provider === 'chatmail') {
          options.push({
            id: 'replyAll',
            name: lang('conversations_message_options_replyAll'),
            onClick: () => handleMessageOption({ type: 'replyAll', messageId })
          },
          {
            id: 'resend',
            name: lang('conversations_message_options_resend'),
            onClick: () => handleMessageOption({ type: 'resend', messageId })
          })
        }
      }

      if (['operator', 'note'].includes(type)) {
        options.push({
          id: 'delete',
          name: lang('dashboard_delete'),
          onClick: () => handleDeleteMessageOption()
        })
      }
      if (attachments.length === 1) {
        options.push({
          id: 'download',
          name: lang('dashboard_download_attachment'),
          onClick: () => {
            onDownloadMultipleFiles({ urls: attachments.map(it => it.urlLong || it.url) })
            toggleDotsOptions()
          }
        })
      }
      if (attachments.length > 1) {
        options.push({
          id: 'downloadAll',
          name: lang('dashboard_download_all'),
          onClick: () => {
            onDownloadMultipleFiles({ urls: attachments.map(it => it.urlLong || it.url) })
            toggleDotsOptions()
          }
        })
        options.push({
          id: 'downloadAllZip',
          name: lang('dashboard_download_all_zip'),
          onClick: () => {
            onDownloadMultipleFilesToZip({ urls: attachments.map(it => it.urlLong || it.url) })
            toggleDotsOptions()
          }
        })
      }

      if (options.length === 0) return null

      return (
        <MenuDotsOptions
          typeOptions='dotsOptionsVertical'
          isOpen={isOpenMessageOptionsSelector}
          id={_id}
          toggleDotsOptions={toggleDotsOptions}
          options={options}
          isOpenModalDelete={isOpenRemoveModal}
          toggleDelete={toggleDelete}
          type={type === 'note' ? type : 'message'}
          eventDelete={()=>{
            handleMessageOption({ type: 'delete', messageId, provider: user.provider_name, content })
            setIsOpenRemoveModal(!isOpenRemoveModal)
          }}
        />
      )
    } catch (e) {
      console.error('Error rendering dots menu options: ', e)
      return null
    }
  }

  if (activitiesTypes?.includes(type)) {
    return (
      <ActivityMsg
        id={_id}
        avatar={operatorPicture}
        name={operatorName || operatorEmail}
        activityData={{
          type,
          text,
          insertBy,
          metadata,
          assignedTo,
          state,
          brandName,
          delegationName,
          date
        }}
      />
    )
  }

  if (status === 'failed') {
    return (
      <FailedMessage
        id={_id}
        type={type}
        message={text}
        errorMessage={errorMessage}
        buttons={buttonsData}
        date={date}
        attachments={attachments}
        renderButtons={buttons}
        operatorPicture={operatorPicture}
        operatorName={operatorName}
        user={user}
        typeTitle={typeTitle}
      />
    )
  }

  if (channelInfo.provider === 'whatsapp' && (header || footer)) {
    return (
      <CloudAPITemplate
        id={_id}
        type={type}
        user={user}
        operatorPicture={operatorPicture}
        operatorName={operatorName}
        header={header}
        body={text}
        status={status}
        channelInfo={channelInfo}
        buttons={buttonsData}
        footer={footer}
        date={date}
        attachments={attachments}
        renderButtons={buttons}
        reactions={content?.reactions || []}
        hiddenReaction={hiddenReaction}
        typeTitle={typeTitle}
      />
    )
  }

  if (['customer', 'customer_location', 'customer_not_supported', 'customer_reply_opt_msg', 'customer_reply'].includes(type)) {
    return (
      <div id={_id} className={`new-message ${type}`}>
        <div className='new-message__header-container'>
          <UserAvatar
            avatar={user.chatType === 'group' ? null : user.avatarUrl}
            channel={convGetChannel(user)}
            sentiment={{
              value: sentiment.value,
              score: sentiment.score,
              sentimentList,
            }}
            onChangeSentiment={value => sentimentAPI.change({
              userId: user.id,
              nodeId: _id,
              operatorId: operator._id,
              data: { sentiment: value }
            })}
            onErrorAvatar={event => {
              event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
              event.onerror = null
            }}
          />
          <div className='new-message__header'>
            <div className='new-message__username-container'>
              <strong>
                <DisplayNameMsg
                  user={user}
                  type={type}
                  typeTitle={typeTitle}
                  fromName={content?.fromName || content?.from}
                />
              </strong>
              {
                !hiddenReaction ? (
                  <FeedReactions
                    messageId={_id}
                    userId={user._id}
                    channel={getChannelAndProvider(user)}
                    activeReaction={props.content?.reactions || []}
                  />
                ) : null
              }
              {content?.outbound && (
                <figure className='new-message__outbound-icon'>
                  <img src={getStaticImage(`/icons/orange-brand/icon-outbound.svg`)} alt='Outbound' />
                </figure>
              )}
            </div>
            {user.provider_name === 'chatmail' && (
              <div className='new-message__header-info'>
                {to?.length > 0 && (
                  <span className='text-ellipsis'>
                    {lang('chatmail_to')}: <strong>{to[0].name || to[0].email}</strong>
                  </span>
                )}
                {cc?.length > 0 && (
                  <span className='text-ellipsis'>
                    Cc: <strong>{cc[0].name || cc[0].email}</strong>
                  </span>
                )}
                {cco?.length > 0 && (
                  <span className='text-ellipsis'>
                    Cco: <strong>{cco[0].name || cco[0].email}</strong>
                  </span>
                )}
              </div>
            )}
          </div>
          {
            renderDotsOptions()
          }
        </div>
        {
          content.inReplyMsg || content.inReplyAttchs?.length ? (
            <div className='new-message__reply-container'>
              <figure className='new-message__reply-icon'>
                <img src={getStaticImage('/icons/orange-brand/icon-reply-dark.svg')} alt='Reply' />
              </figure>
              <div className='new-message__reply-content'>
                {content.inReplyMsg ? (
                  <p className='new-message__reply-text'
                    dangerouslySetInnerHTML={{ __html: content.inReplyMsg }}
                  />
                ) : null}
                {content.inReplyAttchs?.length ? (
                  <div
                    key='message-attachments'
                    className={`
                          message-attachments
                          new-size-font
                          ${content.inReplyAttchs.length > 1 ? 'message-attachments--multiple' : ''}
                        `}
                  >
                    {content.inReplyAttchs.map((attachment, index) => (
                      <Attachment
                        key={index}
                        id={`attachment-${index}`}
                        url={attachment.urlLong || attachment.url}
                        mimeType={attachment.mimeType}
                        mimeSubtype={attachment.mimeSubtype}
                        shortUrl={attachment.url || attachment.shortUrl}
                        thumb={attachment.thumb}
                        withVirus={attachment.withVirus}
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null
        }
        <div className='new-message__body'>
          <div className={`new-message__content ${type === 'customer_reply_opt_msg' ? 'new-message__content--reply' : ''} ${type}`}>
            {
              type === 'customer_not_supported' ? (
                <>
                  <figure>
                    <img src={getStaticImage('/icons/orange-brand/not-supported.svg')} alt='Not supported' />
                  </figure>
                  <p>{lang('conversations_messages_notSupported')}</p>
                </>
              ) : type === 'customer_reply_opt_msg' ? (
                <div className='new-message__reply-btn'>
                  <p>{content.text}</p>
                </div>
              ) : (
                messageFormat({
                  ...content,
                  provider: user.provider_name,
                  signature: showSignature ? contentSignature : null,
                  signatureButton: signatureButton
                })
              )
            }
            <div className='new-message__footer'>
              {user.provider_name === 'chatmail' && !isThread ? (
                <button
                  className='new-message__thread-btn'
                  onClick={() => {
                    setIsOpenModalThread(true)
                    setDataToThread({ user: user, subjectId: content.subjectId })
                  }}
                >
                  <i className='fa fa-ellipsis-h' aria-hidden="true"></i>
                </button>
              ) : null}
              <div className='new-message__date'>
                <span>{getFormatedDate({ isoString: date, withTime: true, withYear: true })}</span>
              </div>
            </div>
          </div>
        </div>
        {
          !hiddenReaction ? (
            <Reactions
              reactions={props.content?.reactions || []}
              messageId={_id}
              userId={user._id}
              channel={getChannelAndProvider(user)}
            />
          ) : null
        }
        {attachErrorType === 'error-download-attachment' ? (
          <AttachmentDownloadError />
        ) : (
          type !== 'customer_not_supported' && content?.attachments?.length ? (
            <div
              key='message-attachments'
              className={`message-attachments new-size-font ${content?.attachments.length > 1 ? 'message-attachments--multiple' : ''}`}
            >
              {!content.isRemoved && content?.attachments.map((a, k) => (
                <Attachment
                  key={k}
                  id={`attachment-${k}`}
                  url={a.urlLong || a.url}
                  mimeType={a.mimeType}
                  mimeSubtype={a.mimeSubtype}
                  shortUrl={a.url || a.shortUrl}
                  thumb={a.thumb}
                  withVirus={a.withVirus}
                  flexDirection="row"
                />
              ))}
            </div>
          ) : null
        )}
        {isOpenModalThread && (
          <ChatChannelThread
            isOpen={isOpenModalThread}
            toggle={()=>setIsOpenModalThread(false)}
            data={dataToThread}
            activitiesTypes={activitiesTypes}
          />
        )}
      </div>
    )
  } else if (type === 'customer_contact') {
    return (
      <div id={_id} className={`new-message ${type}`}>
        <UserAvatar
          avatar={user.avatarUrl}
          channel={convGetChannel(user)}
          onErrorAvatar={event => {
            event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
            event.onerror = null
          }}
        />
        <div className='new-message__body'>
          <div className={`new-message__content ${type}`}>
            <strong>
              <DisplayNameMsg
                user={user}
                type={type}
                typeTitle={typeTitle}
                fromName={content?.fromName || content?.from}
              />
            </strong>
            <FeedReactions
              messageId={_id}
              userId={user._id}
              channel={getChannelAndProvider(user)}
              activeReaction={props.content?.reactions || []}
            />
            <div className='new-message__contacts-container'>
              {contacts?.map((contact, index) => {
                const contactValue = getPrimaryContact(contact)
                return (
                  <div key={index} className='new-message__contact-container'>
                    <figure className='new-message__contact-avatar'>
                      <img
                        src={contact.avatarUrl || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
                        alt={contact.name || ''}
                        onError={event => {
                          event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                          event.onerror = null
                        }}
                      />
                    </figure>
                    <div className='new-message__contact-info'>
                      {contact.name ? (
                        <p
                          title={contact.name}
                          className='new-message__contact-name text-ellipsis'
                        >
                          {contact.name}
                        </p>
                      ) : null}
                      {contactValue ? (
                        <span
                          title={contactValue}
                          className='new-message__contact-value text-ellipsis'
                        >
                          {contactValue}
                        </span>
                      ) : null}
                    </div>
                    <div className='new-message__contact-actions'>
                      <button
                        className='new-message__btn new-message__btn--contact-details'
                        onClick={() => toggleSidePopup({ contentType: 'contact', contentData: contact })}
                      >
                        <figure>
                          <img src={getStaticImage('/icons/orange-brand/icon-info-primary-dark.svg')} alt='Details' />
                        </figure>
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='new-message__date'>
              <span>{getFormatedDate({ isoString: date, withTime: true, withYear: true })}</span>
            </div>
          </div>
        </div>
        <Reactions
          reactions={props.content?.reactions || []}
          messageId={_id}
          userId={user._id}
          channel={getChannelAndProvider(user)}
        />
      </div>
    )
  } else {
    return (
      <div id={_id} className={`new-message ${type}`}>
        <div className='new-message__header-container'>
          <UserAvatar
            avatar={type.toLowerCase().includes('customer') && user.avatarUrl
              ? user.avatarUrl
              : operatorPicture
            }
            channel={convGetChannel(user)}
            onErrorAvatar={event => {
              event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
              event.onerror = null
            }}
          />
          <div className='new-message__header'>
            <div className='new-message__username-container'>
              <strong>
                <DisplayNameMsg
                  user={user}
                  type={type}
                  typeTitle={typeTitle}
                  operatorName={operatorName}
                />
              </strong>
              {
                !hiddenReaction
                  ? (
                    <FeedReactions
                      messageId={_id}
                      userId={user._id}
                      channel={getChannelAndProvider(user)}
                      activeReaction={props.content?.reactions || []}
                    />
                  ) : null
              }
              {content?.outbound && (
                <figure className='new-message__outbound-icon'>
                  <img src={getStaticImage(`/icons/orange-brand/icon-outbound.svg`)} alt='Outbound' />
                </figure>
              )}
            </div>
            {user.provider_name === 'chatmail' && (
              <div className='new-message__header-info'>
                {to?.length > 0 && (
                  <span className='text-ellipsis'>
                    {lang('chatmail_to')}: <strong>{to[0].name || to[0].email}</strong>
                  </span>
                )}
                {cc?.length > 0 && (
                  <span className='text-ellipsis'>
                    Cc: <strong>{cc[0].name || cc[0].email}</strong>
                  </span>
                )}
                {cco?.length > 0 && (
                  <span className='text-ellipsis'>
                    Cco: <strong>{cco[0].name || cco[0].email}</strong>
                  </span>
                )}
              </div>
            )}
          </div>
          {
            renderDotsOptions()
          }
        </div>
        {
          content.inReplyMsg || content.inReplyAttchs?.length ? (
            <div className='new-message__reply-container'>
              <figure className='new-message__reply-icon'>
                <img src={getStaticImage('/icons/orange-brand/icon-reply-dark.svg')} alt='Reply' />
              </figure>
              <div className='new-message__reply-content'>
                {content.inReplyMsg ? (
                  <p className='new-message__reply-text'
                    dangerouslySetInnerHTML={{ __html: content.inReplyMsg }}
                  />
                ) : null}
                {content.inReplyAttchs?.length ? (
                  <div
                    key='message-attachments'
                    className={`
                          message-attachments
                          new-size-font
                          ${content.inReplyAttchs.length > 1 ? 'message-attachments--multiple' : ''}
                        `}
                  >
                    {content.inReplyAttchs.map((attachment, index) => (
                      <Attachment
                        key={index}
                        id={`attachment-${index}`}
                        url={attachment.urlLong || attachment.url}
                        mimeType={attachment.mimeType}
                        mimeSubtype={attachment.mimeSubtype}
                        shortUrl={attachment.url || attachment.shortUrl}
                        thumb={attachment.thumb}
                        withVirus={attachment.withVirus}
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null
        }
        <div className='new-message__body'>
          <div className={`new-message__content ${type} ${!content?.text ? 'no-padding' : ''}`}>
            {messageFormat({ ...content, provider: user.provider_name, signature: showSignature ? contentSignature : null, signatureButton: signatureButton })}
            <div className='new-message__footer'>
              {user.provider_name === 'chatmail' && !isThread ? (
                <button
                  className='new-message__thread-btn'
                  onClick={() => {
                    setIsOpenModalThread(true)
                    setDataToThread({ user: user, subjectId: content.subjectId })
                  }}
                >
                  <i className='fa fa-ellipsis-h' aria-hidden="true"></i>
                </button>
              ) : null}
              <div className={`new-message__date ${type !== 'note' ? 'new-message__date--right-side' : ''}`}>
                <span>{getFormatedDate({ isoString: date, withTime: true, withYear: true })}</span>

                <MessageStatus
                  status={status}
                  channel={`${channelInfo.provider}_${channelInfo.channel}`}
                />
              </div>
            </div>
          </div>
        </div>
        {
          !hiddenReaction
            ? (
              <Reactions
                reactions={content?.reactions || []}
                messageId={_id}
                userId={user._id}
                channel={getChannelAndProvider(user)}
              />
            )
            : null
        }
        {errorMessage ? (
          <p
            title={errorMessage}
            className='new-message__error-text'
          >
            {lang('dashboard_error-sending-message')}.
          </p>
        ) : null}
        {!content?.isRemoved && chatmailProviders.includes(content?.channel) && buttons(content?.buttons)}
        {!content.isRemoved && content?.attachments?.length > 0 ? (
          <div
            key='message-attachments'
            className={`message-attachments new-size-font ${content?.attachments.length > 1 ? 'message-attachments--multiple' : ''}`}
          >
            {!content?.isRemoved && content?.attachments.map((a, k) => (
              <Attachment
                key={k}
                id={`attachment-${k}`}
                url={a.urlLong || a.url}
                mimeType={a.mimeType}
                mimeSubtype={a.mimeSubtype}
                shortUrl={a.url || a.shortUrl}
                thumb={a.thumb}
                withVirus={a.withVirus}
              />
            ))}
          </div>
        ) : null}
        {isOpenModalThread && (
          <ChatChannelThread
            isOpen={isOpenModalThread}
            toggle={()=>setIsOpenModalThread(false)}
            data={dataToThread}
            activitiesTypes={activitiesTypes}
          />
        )}
      </div>
    )
  }
}

export const DraftMessage = ({ user, content, toggleDeleteDraftModal, handleEditDraft, handleToggleShowHideDraft }) => {
  const { _id, provider, isPrivate, operatorName, operatorEmail, operatorPicture , to, cc, cco, users, message, createdAt } = content

  return (
    <div id={_id} className='new-message'>
      <div className='new-message__header-container'>
        <UserAvatar
          avatar={operatorPicture}
          channel={convGetChannel(user)}
          onErrorAvatar={event => {
            event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
            event.onerror = null
          }}
        />
        <div className='new-message__header'>
          <strong className='new-message__operator-name text-ellipsis'>{operatorName || operatorEmail}</strong>
          {provider === 'chatmail' && (
            <div className='new-message__header-info'>
              {to?.length > 0 && (
                <span className='text-ellipsis'>
                  {lang('chatmail_to')}: <strong>{users?.find(user => user.id === to[0].id)?.name || users?.find(user => user.id === to[0].id)?.email}</strong>
                </span>
              )}
              {cc?.length > 0 && (
                <span className='text-ellipsis'>
                  Cc: <strong>{users?.find(user => user.id === cc[0].id)?.name || users?.find(user => user.id === cc[0].id)?.email}</strong>
                </span>
              )}
              {cco?.length > 0 && (
                <span className='text-ellipsis'>
                  Cco: <strong>{users?.find(user => user.id === cco[0].id)?.name || users?.find(user => user.id === cco[0].id)?.email}</strong>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className='new-message__body'>
        <div className='new-message__content new-message__content--draft-color'>
          {messageFormat({ ...message, provider: user.provider_name, channel: content?.channel })}
          <div className='new-message__message-options'>
            <button className='new-message__btn' onClick={() => handleToggleShowHideDraft({  draftId: _id })}>
              <figure>
                {isPrivate ? (
                  <img src={getStaticImage('/icons/orange-brand/icon-hidden.svg')} alt='Hidden message' />
                ) : (
                  <img src={getStaticImage('/icons/orange-brand/icon-view.svg')} alt='View message' />
                )}
              </figure>
            </button>
            <button className='new-message__btn' onClick={() => handleEditDraft({ draftId: _id })}>
              <figure>
                <img src={getStaticImage('/icons/orange-brand/icon-new.svg')} alt='Edit message' />
              </figure>
            </button>
            <button className='new-message__btn' onClick={() => toggleDeleteDraftModal({ draftId: _id })}>
              <i className='fa fa-trash'></i>
            </button>
          </div>
          <div className='new-message__date new-message__date--right-side'>
            <span>{getFormatedDate({ isoString: createdAt, withTime: true, withYear: true })}</span>
          </div>
        </div>
      </div>
      {content?.isRemoved && chatmailProviders.includes(content?.channel) && buttons(message?.buttons)}
    </div>
  )
}

export const DeferredMessage = ({ content: contentData, deleteDeferred }) => {
  const { _id, scheduledAt, content, attachments } = contentData
  const scheduledDate = new Date(scheduledAt)

  return (
    <div id={_id} className='deferred-container'>
      <div className='deferred-message'>
        {messageFormat({ text: content, attachments: attachments || [] })}
      </div>
      <div className='scheduled-label'>
        <p>{lang('conversations_messages_deferred_schedule', { date: `${scheduledDate.getDate()}/${scheduledDate.getMonth() + 1}`, time: getFlightDateTime(scheduledDate) })}</p>
        <i className='fa fa-trash-o' onClick={() => deleteDeferred(_id)} />
      </div>
    </div>
  )
}

export default Message